import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const TitleStyled = styled.div<T>`
  font-size: 2em;
  text-align: center;
  padding: 1em 0;
`;
